import { Box, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { UomText } from 'src/common/enumerations/unit-of-measure-type';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './tare-weight-setting-styles';

const TareWeightSetting: React.FC<ITareWeightSetting> = (props): JSX.Element => {
  const classes = styles();
  const [selectedProduct, setSelectedProduct] = React.useState<string>('');
  const precision = useSelector(
    (state: AppState) =>
      state.touchPoint.touchPointConfiguration.defaultWeightUnitOfMeasurePrecision,
  );

  const handleSelectedProduct = async (product: IItemLookup): Promise<void> => {
    await withSpinner(async () => {
      if (product.itemId) {
        setSelectedProduct(product.itemId);
        await props.onSelectProduct(product);
      }
    });
  };

  return (
    <Box className={`${classes.productBox}`}>
      <Grid
        className={`
            ${classes.linkedTareWeightItemCard}
            product-container
            ${selectedProduct === props.product.itemId ? classes.selectedItem : ''}
          `}
        data-testid='tare-weight-item-list'
        onClick={(): Promise<void> => handleSelectedProduct(props.product)}
      >
        <Typography
          data-testid='tare-weight-item-list-description'
          className={classes.linkedTareWeightItemCardHeader}
        >
          {props.product.description}
        </Typography>
        {props.product.itemMeasurements && (
          <Typography className={`${classes.price} ${classes.gridPrice}`}>
            {`${props.product.itemMeasurements.weight?.toFixed(precision)} ${
              UomText[
                props.product.itemMeasurements.unitsOfMeasure
                  ? props.product.itemMeasurements.unitsOfMeasure
                  : ''
              ]
            }`}
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

interface ITareWeightSetting {
  onSelectProduct: (product: IItemLookup) => Promise<void>;
  product: IItemLookup;
}

export default TareWeightSetting;
